import React from 'react';
import { motion } from 'framer-motion';

const TicketsByAgent = ({ agentStats }) => {
  return (
    <div style={{
      background: 'linear-gradient(160deg, #161731 0%, #12132a 55%, #0f1024 100%)',
      border: '1px solid rgba(255,255,255,0.07)',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: '#6B7391' }}>
          Desempeño por agente
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 11, color: '#6B7391' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#DC1F26', display: 'inline-block' }} />
            Abiertos
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#4ADE80', display: 'inline-block' }} />
            Cerrados
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxHeight: 260, overflowY: 'auto', paddingRight: 4 }}>
        {Array.isArray(agentStats) && agentStats.length > 0 ? (
          agentStats.map((agent, i) => {
            const total = (agent.open || 0) + (agent.closed || 0);
            const openPct = total > 0 ? (agent.open / total) * 100 : 0;
            const closedPct = 100 - openPct;

            return (
              <motion.div
                key={agent.name}
                initial={{ opacity: 0, x: -8 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.35, ease: [0.16,1,0.3,1], delay: i * 0.04 }}
                style={{ display: 'flex', alignItems: 'center', gap: 12 }}
              >
                <span style={{ fontSize: 12, color: '#9BA3B8', minWidth: 90, maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={agent.name}>
                  {agent.name}
                </span>
                <div style={{ flex: 1, height: 8, borderRadius: 8, overflow: 'hidden', display: 'flex', background: 'rgba(255,255,255,0.05)' }}>
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${openPct}%` }}
                    transition={{ duration: 0.8, ease: [0.16,1,0.3,1], delay: 0.1 + i * 0.04 }}
                    style={{ height: '100%', background: 'linear-gradient(90deg,#DC1F26,#F87171)', borderRadius: '8px 0 0 8px' }}
                    title={`${agent.open} Abiertos`}
                  />
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${closedPct}%` }}
                    transition={{ duration: 0.8, ease: [0.16,1,0.3,1], delay: 0.15 + i * 0.04 }}
                    style={{ height: '100%', background: 'linear-gradient(90deg,#22C55E,#4ADE80)', borderRadius: '0 8px 8px 0' }}
                    title={`${agent.closed} Cerrados`}
                  />
                </div>
                <span style={{ fontSize: 11, color: '#4A5270', minWidth: 40, textAlign: 'right' }}>
                  {agent.open}/{agent.closed}
                </span>
              </motion.div>
            );
          })
        ) : (
          <div style={{ textAlign: 'center', color: '#3E4460', fontSize: 13, padding: '16px 0' }}>
            No hay información de agentes disponible
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketsByAgent;
